export enum VisaStatesEnum {
  OPEN = 'O',
  CLOSED = 'C',
  LATE = 'L',
  NO_VISA = 'N',
}
